import styled from 'styled-components';

import { lightGray } from '../../modules/colors';

const size = {
  sm: { width: 20, height: 20 },
  lg: { width: 30, height: 30 },
  xxl: { width: 120, height: 120 },
};

export const Wrapper = styled.div`
  background-color: ${lightGray};
  ${(props) => size[props.size]}
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`;
